import { Box, Typography } from "../legacy-ui/materialCompat";
import {
  FocusContext,
  useFocusable,
} from "@noriginmedia/norigin-spatial-navigation";
import { useCallback, useRef } from "react";
import { MoviesSlider } from "./moviesList";
import { BackBarButtonMini } from "../common/backBarButton";
import smoothScroll from "../../utils/animateScroll";
import { getVerticalFocusScrollTarget } from "../../utils/focusScroll";
import { useInputMode } from "../../utils/hooks/useInputMode";
import LazyRow from "../common/LazyRow";

const GenreContent = ({ data = {} }) => {
  const { ref, focusKey } = useFocusable();
  const { contents, children } = data;

  const hasContentfulItem = useRef({ current: false });

  if (contents.length > 0) {
    contents.forEach((item) => {
      if (item.data.length > 0) {
        hasContentfulItem.current = true;
      }
    });
  }

  const { isMouseFocus } = useInputMode();
  const onRowFocus = useCallback(
    (props) => {
      if (isMouseFocus) return;
      const targetScroll = getVerticalFocusScrollTarget(ref.current, props || {}, {
        topPadding: 88,
        bottomPadding: 128,
      });

      smoothScroll(ref, targetScroll, 500);
    },
    [ref, isMouseFocus]
  );

  return (
    <div className="legacy-route-content legacy-route-content-top-only">
      <FocusContext.Provider value={focusKey}>
        <div className="legacy-route-scroll" ref={ref}>
          <div>
            <div className="flex items-center mb-5">
              <BackBarButtonMini />
              <Typography
                variant="h4"
                fontWeight={700}
                mb={0}
                mr={3}
                color={"white"}
              >
                {data?.result?.name}
              </Typography>
            </div>
            <Box>
              {hasContentfulItem.current === true ? (
                contents?.map((item, index) => {
                  const title = children?.find((x) => x.key === item.key)?.meta
                    ?.bin?.name;
                  if (item.data && item.data.length > 0) {
                    return (
                      <LazyRow index={index} key={item._id}>
                        <MoviesSlider
                          movies={item.data}
                          rowTitle={title}
                          onFocus={onRowFocus}
                          shouldFocusSelf={index === 0}
                          id={item._id}
                          nextPlayGuide={{
                            type: "genre",
                            slug: item.key,
                            name: title || "",
                          }}
                        />
                      </LazyRow>
                    );
                  } else {
                    return null;
                  }
                })
              ) : (
                <div className="bg-[#212121] p-5 rounded-xl text-lg">
                  <Typography color={"white"} fontFamily={"AnjomanMaxFN-Regular"}>
                    {" "}
                    محتوایی یافت نشد
                  </Typography>
                </div>
              )}
            </Box>
          </div>
        </div>
      </FocusContext.Provider>
    </div>
  );
};
export default GenreContent;
